<template>
  <div class="hc-profile-nudge-bar" v-if="!dismissed">
    <div class="hc-profile-nudge" role="status" aria-live="polite">
      <div class="container hc-profile-nudge__inner">
        <p class="hc-profile-nudge__text">
          <strong>Complete your profile</strong>
          <span class="hc-profile-nudge__links">
            <template v-if="!seeker.resume_path">
              <button type="button" class="hc-profile-nudge__link" @click="upload('resume')">Upload resume</button>
            </template>
            <span v-if="!seeker.resume_path && !seeker.visume_path" class="hc-profile-nudge__dot" aria-hidden="true">·</span>
            <template v-if="!seeker.visume_path">
              <button type="button" class="hc-profile-nudge__link" @click="upload('visume')">Add visume</button>
            </template>
            <span v-if="(!seeker.resume_path || !seeker.visume_path)" class="hc-profile-nudge__dot" aria-hidden="true">·</span>
            <router-link to="/myprofile" class="hc-profile-nudge__link">My profile</router-link>
          </span>
        </p>
        <button type="button" class="hc-profile-nudge__close" @click="dismissNudge" aria-label="Dismiss">&times;</button>
      </div>
    </div>
    <VisumeModal :visume="seeker.visume_path" :open="visumeModal.open" v-if="seeker.token" />
    <b-modal
      ref="upload-resume"
      title="Upload Resume"
      content-class="hc-modal"
      header-class="hc-modal__header"
      body-class="hc-modal__body"
      hide-footer
    >
      <v-form ref="form" lazy-validation v-model="valid">
        <v-file-input accept=".doc,.docx,.rtf,.pdf" v-model="resume" placeholder="Post resume" append-icon="mdi-file" prepend-icon="" :rules="[v => !!v || 'Upload valid resume']" show-size outlined></v-file-input>
      </v-form>
      <div class="hc-modal__actions">
        <button type="button" class="hp-btn hp-btn--outline" @click.prevent="closeModal('upload-resume')">Cancel</button>
        <button type="button" class="hp-btn hp-btn--primary" @click.prevent="uploadResume()" v-if="!loading">Save</button>
        <button type="button" class="hp-btn hp-btn--primary" disabled v-if="loading">Saving…</button>
      </div>
    </b-modal>
  </div>
</template>

<script>
const VisumeModal = () => import(/* webpackPrefetch: true */ "@/components/VisumeModal");

import AwsUpload from "../../utils/s3upload"
import Actions from '../libraries/apiActions.js';
import '../assets/home-page.css';
import '../assets/site-chrome.css';
export default{
  components:{
    VisumeModal
  },
  data(){
    return {
      dismissed: !!sessionStorage.getItem('hc-profile-nudge-dismissed-v2'),
      visumeModal:{
        open:'exit',
      },
      visume:'',
      action:new Actions(),
      resume_path:null,
      resume: null,
      update:{
        resume:null
      },
      valid:true,
      loading:false
    }
  },
  computed: {
    seeker() {
      return this.$cookies.get('hire-seeker') || {};
    },
  },
  methods:{
    dismissNudge() {
      this.dismissed = true;
      sessionStorage.setItem('hc-profile-nudge-dismissed-v2', '1');
      this.$root.$emit('profile-nudge-dismissed');
    },
    openModal : function(type= ''){
      this.open = type == "" ? this.open : type;
      this.visumeModal.open = 'exit';
      this.visumeModal.open = type;
    },
    closeModal(data){
      this.$refs[data].hide();
      if(data == 'profile-alert'){
        let cookie = this.$cookies.get('hire-seeker');
        let updated_cookie = {token:cookie.token,name:cookie.name,visume_path:cookie.visume_path,resume_path:cookie.resume_path,alert:'no'};
        this.$cookies.remove("hire-seeker");
        this.$cookies.set("hire-seeker",updated_cookie);
      }
    },
    upload(data){
      if(data == 'visume'){
        this.openModal('visume');
      }else if(data == 'resume'){
        this.$refs['upload-resume'].show();
      }
    },
    async uploadResume(){
      let token = this.$cookies.get("hire-seeker").token;
      this.valid = this.$refs.form.validate();
      var self = this;
      if(this.valid == true){
        this.loading = true;
        const file = this.resume;
        const awsUploader = new AwsUpload();
          try {
            var extension = this.resume.name.split('.')[this.resume.name.split('.').length-1]
            var d = new Date();
            var month = d.getMonth() + 1;
            var day = d.getDate();
            var current_date =d.getFullYear() +"/" +(month < 10 ? "0" : "") +month +"/" +(day < 10 ? "0" : "") +day;
            var timestamp = Math.floor(Date.now() / 1000);
            var filename = 'resume/'+ current_date+"/"+self.$cookies.get('hire-seeker').name + timestamp + "."+extension;
            const response = await awsUploader.uploadToS3(file, filename);
            this.update.resume = response.url;
            this.action.updateResume(this.update.resume,token).then(data =>{
              if(data.message == "Resume Updated"){
                this.loading = false;
                this.resume = false;
                this.$refs['upload-resume'].hide();
                let cookie = this.$cookies.get('hire-seeker');
                let updated_cookie = {token:cookie.token,name:cookie.name,visume_path:cookie.visume_path,resume:'yes',resume_path:this.update.resume,alert:cookie.alert};
                this.$cookies.remove("hire-seeker");
                this.$cookies.set("hire-seeker",updated_cookie);
                location.reload();
              }else{
                this.loading = false;
              }
            }).catch(err =>{
              this.loading = false;
              console.log(err);
            })
          } catch (error) {
            console.error('Failed to upload file to S3:', error);
          }

      }
    }
  }
}
</script>
